import React, { useCallback, useState } from "react"
import CommonTypo from "../../../components/CommonTypo"
import { Autocomplete, Box, TextField, Paper, Button } from "@mui/material"
import NewButton from "../../../components/NewButton"
import { makeStyles } from "@material-ui/core";
import _debounce from "lodash/debounce";
import palette from "../../../theme/palette";
import { pxToRem } from "../../../theme/typography";
import shape from "../../../theme/shape";
import { onboardingPlansService } from "../../../services/onboardingPlans";

const useStyles = makeStyles((theme) => ({
    selectionBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "42px",
        gap: "8px",
        borderRadius: "20px",
        border: "1px solid var(--color-border)",
        paddingTop: "8px",
        paddingRight: "24px",
        paddingBottom: "8px",
        paddingLeft: "24px",
        // "&:hover": {
        //     border: "1px solid var(--color-new-main)",
        // },
    },

}))

const Step7 = ({ setNextStep, setPreviousStep, planReflectives, setPlanReflectives, planSelectedReflectives, setSelectedPlanReflectives, isDarkMode = false }) => {
    const classes = useStyles()
    // let fundData = [...(planSelectedReflectives || [])]
    // let found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
    // if (props?.planStep === 1) {
    // fundData = [...(props.planSelectedReflectives || [])]
    // found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
    // }
    // if (props?.planStep === 2) {
    //     fundData = [...(props.planSelectedReflectives || [])]
    //     found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
    // }
    // if (props?.planStep === 3) {
    //     fundData = [...(props.planSelectedReflectives || [])]
    //     found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
    // }
    return <>
        <Box display={"flex"} flexDirection={"column"} gap={"4px"} alignItems={"center"}>
            <CommonTypo size={32} fontWeight={700} color="var(--color-text-primary)" lineHeight={36} extraSx={{
                whiteSpace: "nowrap"
            }}>Finally, reflections</CommonTypo>
            <CommonTypo size={16} fontWeight={400} color={isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'} lineHeight={22} >Open-ended reflections that help you capture the 'why' behind your numbers. These insights add context to your data and help uncover deeper patterns in your behavior.</CommonTypo>
        </Box>
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexWrap={"wrap"} sx={{
            maxHeight: '38vh',
            width: "100%",
            overflowY: 'auto',
            gap: "12px"
        }}>
            {planReflectives.map(it => {
                let fundData = []
                let found = undefined
                // if (props?.planStep === 1) {
                fundData = [...(planSelectedReflectives || [])]
                found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
                // }
                // if (props?.planStep === 2) {
                //     fundData = [...(props.planSelectedReflectives || [])]
                //     found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
                // }
                // if (props?.planStep === 3) {
                //     fundData = [...(props.planSelectedReflectives || [])]
                //     found = fundData.find(ite => ite.reflectiveId === it.reflectiveId)
                // }
                return <Box className={classes.selectionBox} sx={{

                    border: found ? "1px solid var(--color-new-main)" : "1px solid var(--color-border)",
                }} onClick={() => {
                    if (found) {
                        fundData = fundData.filter(ite => ite.reflectiveId !== it.reflectiveId)
                        setSelectedPlanReflectives(fundData)
                        // const foundAlreadySelected = props.secondselectedPlans.find(ite => ite.categoryId === it.categoryId)
                        // if (foundAlreadySelected) {
                        //     // setSecondSelectedPlans([])
                        //     // setSelectedPlanReflectives([])
                        //     // setSelectedPlanReflectives([])
                        //     // setSelectedPlanReflectives([])
                        // }
                    } else {
                        if (fundData.length < 2) {
                            fundData.push(it)
                            setSelectedPlanReflectives(fundData)
                        }
                    }
                }}>
                    <CommonTypo size={16} color={isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'}>{it.question}</CommonTypo>
                </Box>
            })}
        </Box>
        <CommonTypo size={16} color={isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'}>Select up to <strong>2 reflections</strong></CommonTypo>

    </>
}

export default Step7